// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonSecurity = {
  normal: "正常",
  mustChangePassword: "需改密",
  locked: "已锁定",
  unlocked: "未锁定",
  failedLoginAttempts: "失败 {count} 次",
  superuser: "超级管理员",
} as const;
